import { render, staticRenderFns } from "./BDateTime.vue?vue&type=template&id=0859308d&"
import script from "./BDateTime.vue?vue&type=script&lang=js&"
export * from "./BDateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports